/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGeoData, ILoginUser, IOpportunities, IProfile, IQualification } from '../../models/service/service';
import { IInitialState } from '../../models/store/store';
import { IVolunteer } from '../../pages/opportunityDetails/volunteers/types';

const initialState: IInitialState = {
  tabs: 0,
  errors: '',
  addresses: [],
  profile: null,
  loading: false,
  volunteers: [],
  inviteToken: '',
  opportunities: [],
  volunteerAmount: 0,
  conversationId: null,
  successVisible: false,
  opportunitiesById: null,
  resetPasswordEmail: null,
  requiredQualification: [],
  user: { email: '', password: '' },
  noticePages: [],
};

export const organizerSlice = createSlice({
  name: 'organizer',
  initialState,
  reducers: {
    loadStarted(state) {
      state.loading = true;
    },
    setTabs(state, action: PayloadAction<number>) {
      state.tabs = action.payload;
    },
    loadCompleted(state) {
      state.loading = false;
    },
    fetchError(state, action: PayloadAction<string>) {
      state.errors = action.payload;
    },
    setAddresses(state, action: PayloadAction<string[]>) {
      state.addresses = action.payload;
    },
    setInviteToken(state, action: PayloadAction<string>) {
      state.inviteToken = action.payload;
    },
    getLoginUser(state, action: PayloadAction<ILoginUser>) {
      state.user = action.payload;
    },
    setConversationId(state, action: PayloadAction<string | null>) {
      state.conversationId = action.payload;
    },
    setSuccessVisible(state, action: PayloadAction<boolean>) {
      state.successVisible = action.payload;
    },
    setVolunteerAmount(state, action: PayloadAction<number>) {
      state.volunteerAmount = action.payload;
    },
    setVolunteers(state, action: PayloadAction<IVolunteer[]>) {
      state.volunteers = action.payload;
    },
    setResetPasswordEmail(state, action: PayloadAction<string>) {
      state.resetPasswordEmail = action.payload;
    },
    setProfile(state, action: PayloadAction<IProfile>) {
      state.profile = action.payload;
    },
    setOpportunities(state, action: PayloadAction<IOpportunities[]>) {
      state.opportunities = action.payload;
    },
    setNoticePages(state, action: PayloadAction<IOpportunities[]>) {
      state.noticePages = action.payload;
    },
    setOpportunitiesById(state, action: PayloadAction<IOpportunities>) {
      state.opportunitiesById = action.payload;
    },
    setRequiresQualification(state, action: PayloadAction<IQualification[]>) {
      state.requiredQualification = action.payload;
    },
    deleteVolunteer(state, { payload }: PayloadAction<string>) {
      state.volunteers = state.volunteers.filter(({ id }) => id !== payload);
    },
  },
  extraReducers: {},
});

export const { setResetPasswordEmail } = organizerSlice.actions;
export const reducer = organizerSlice.reducer;
